import { createContext, useState } from "react";
import { makeRequest } from "../axios";
 
export const TestContext = createContext();

export const TestContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [tests, setTests] = useState(null);
  const [passingTest, setPassingTest] = useState(null);
  const [testContinue, setTestContinue] = useState(null);
  const [finish, setFinish] = useState(null);
  

  const checkActualTest = async () => {
   
    setLoading(true);
    const res = await makeRequest
      .get("/test")

      .finally(() => {
        setLoading(false);
      });
    return res;
  };

  const setStatesNull = () => {
    setTests(null);
    setPassingTest(null);
    setTestContinue(null);
    setFinish(null);
  };

  const getTestById = async (userIIN, testId) => {
    try{
      setLoading(true);
      if (tests) {
        const res = await makeRequest
          .get(`/test/${userIIN}/${testId}`)
          .finally(() => {
            setLoading(false);
          });

        return res;
      }
    } catch(err)
    {
      console.log(err.response)
      return err;
    }
  }; 

  const setFinishWithoutAnswers = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await makeRequest
      .get(`/test/${user.iin}/finishTest`)
      .finally(() => {
        setLoading(false);
      });

    if (res.status === 200) {
      makeRequest
        .get(`/test/${user.id}/actual_result?finish=1`)
        .then((response) => {
          if (response.status === 200) {
            if (response.data) {
              setFinish(response.data);
              setTests(null);
              setPassingTest(null);
              setTestContinue(null);
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const postTestById = async (userIIN, testId, answer) => {
    setLoading(true);

    if (tests) {
      const res = await makeRequest
        .post(`/test/${userIIN}/${testId}`, answer)
        .finally(() => {
          setLoading(false);
        });
 
      if (res.status === 201) {
        const user = JSON.parse(localStorage.getItem("user"));
        setLoading(true);
        makeRequest
          .get(`/test/${user.id}/actual_result?finish=1`)
          .then((res) => {
            if (res.status === 200) {
              if (res.data) {
                setFinish(res.data);
                setTests(null);
                setPassingTest(null);
                setTestContinue(null);
              }
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }

      return res;
    }
  };

  const checkFinish = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    makeRequest
      .get(`/test/${user.id}/actual_result?finish=1`) 
      .then((res) => {
        if (res.status === 200) {
          if (res.data) {
            setFinish(res.data);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updatePassingTest = (testId) => {
    setPassingTest((prev) => {
      return prev.filter((el) => {
        return el !== testId;
      });
    });
  };

  const uploadPage = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setLoading(true);
      makeRequest.get(`/test/${user.iin}/all`).then((res) => {
        if (res.data) {
          setTests(res.data);
          setPassingTest(res.data);
        }
      });

      makeRequest
        .get(`/test/${user.id}/actual_result`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              setTestContinue(res.data);
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };


  const updateTimer = () => {
    makeRequest
        .post(`/test/timer`)  
  }

  return (
    <TestContext.Provider
      value={{
        loading,
        checkActualTest,
        tests,
        getTestById,
        updatePassingTest,
        passingTest,
        postTestById,
        testContinue,
        uploadPage,
        finish,
        setStatesNull,
        setFinish,
        setFinishWithoutAnswers,
        updateTimer
      }}
    >
      {children}
    </TestContext.Provider>
  );
};
